import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRefresh02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.307 7.2a9.65 9.65 0 0 0-8.356-4.8 9.65 9.65 0 0 0-8.946 6m14.372 0H22.2V3.6M3.693 16.8a9.65 9.65 0 0 0 8.357 4.8 9.65 9.65 0 0 0 8.945-6m-14.372 0H1.8v4.8"
    />
  </svg>
);
export default SvgArrowRefresh02;
